module.exports = __webpack_public_path__ + "static/media/specifics-top.f928a190.png";